import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Config from '../utils/config.service';
import HttpHelper from '../utils/http-helper.service';

@Injectable({ providedIn: 'root' })
export default class BusinessRestServices {
	private httpClient: HttpClient = inject(HttpClient);
	private config: Config = inject(Config);
	private httpHelper: HttpHelper = inject(HttpHelper);

	getWorkers(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/worker', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	getSurveys(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/survey', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getTrainingPrograms(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/training-program', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getTrainingProgramKpi(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/training-program/' + params.id + '/kpi', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getTrainingProgramLearners(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/training-program/' + params.id + '/learners', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getDataForPsychologicalSurvey(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/survey/getUserAnswers', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	checkTokenValidity(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'publicrest/business/survey/checkTokenValidity', {
			withCredentials: true,
			params: params,
			responseType: 'text',
			observe: 'response',
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getPublicQuestionnaire(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'publicrest/questionnaire', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	submitPublicQuestionnaire(params?, data?, successCallback?, errorCallback?) {
		var queryParams: any = {};
		if (params.requestId) queryParams.requestId = params.requestId;
		if (params.userId) queryParams.userId = params.userId;

		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'publicrest/questionnaire/submit/' + params.questionnaireId + '/' + params.language, data, {
			params: queryParams,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	updateQuestionnaireAnswerToken(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'publicrest/business/survey/update/questionnaireAnswerToken', {
			withCredentials: true,
			params: params,
			observe: 'response',
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getDependents(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/worker/dependent', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	inviteWorker(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/business/worker/invite', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	inviteDependent(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/business/worker/dependent/invite', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getSettings(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/client/settings', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getDashboard(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/service/dashboard', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	activateWorker(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/business/worker/' + params.id + '/activate', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	activateDependent(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/business/worker/dependent/' + params.id + '/activate', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	deleteInvitation(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.delete(this.config.getRestUrl() + 'rest/business/worker/invitation/' + params.invitationId + '', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	deleteSurvey(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.delete(this.config.getRestUrl() + 'rest/business/survey/' + data.surveyId, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	deleteProgramCampaign(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.delete(this.config.getRestUrl() + 'rest/business/training-program/' + data.programCampaignId, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	updateProgramCampaign(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/business/training-program/update', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}


	deleteDependentInvitation(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.delete(this.config.getRestUrl() + 'rest/business/worker/dependent/invitation/' + params.invitationId + '', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	deActivateWorker(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/business/worker/' + params.id + '/deactivate', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	toggleAdminAssistantStatus(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/business/worker/' + params.id + '/admin/assistant/' + params.status + '', {}, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	deActivateDependent(params?, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.put(this.config.getRestUrl() + 'rest/business/worker/dependent/' + params.id + '/deactivate', data, {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	acceptBusinessInvite(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/business/worker/accept/recent', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	declineBusinessInvite(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/business/worker/decline/recent', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getOnDemandSettings(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'publicrest/business/service/ondemand/settings', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getBenuQrOnDemandSetting(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'publicrest/business/service/benu-qr/ondemand/settings', {
			params: params,
			withCredentials: false
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getSynctuitionStatus(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/synctuition/status', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	activateSynctuition(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/synctuition/activate', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getInstantlyAvailable(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/business/service/instant/availability', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

}
